/**
 * Carries a failed platform return (POST /launch/return rejected, e.g.
 * NO_PLATFORM_ACCESS) from `goToPortalReturn` to the launcher it falls back to,
 * so the employee sees the translated reason instead of a silent redirect.
 * Module state is enough: the fallback is an in-app navigation, not a reload.
 */
let pending: unknown;

export function setLaunchFailure(error: unknown): void {
  pending = error;
}

/** Returns the stored failure once and clears it. */
export function takeLaunchFailure(): unknown {
  const error = pending;
  pending = undefined;
  return error;
}
